import React from 'react';
import { BarChart3Icon, DoorOpenIcon, MailIcon, MousePointerClickIcon, NewspaperIcon, UsersIcon } from 'lucide-react';
import { Slide } from '../Slide';
import { InView } from '../InView';
import { SlideHeadline } from '../SlideHeadline';
import { useCases } from '../../../data/deck';
import type { UseCaseIcon } from '../../../data/deck';
const ICONS: Record<UseCaseIcon, React.ComponentType<{
  className?: string;
}>> = {
  research: BarChart3Icon,
  door: DoorOpenIcon,
  attention: MousePointerClickIcon,
  study: NewspaperIcon,
  email: MailIcon,
  congress: UsersIcon
};
export function UseCasesSlide() {
  return <Slide id="useCases" data-id="element-314" data-mp="37qw74gkt8b4z">
      <div className="grid items-end gap-8 lg:grid-cols-[minmax(0,1fr)_420px] lg:gap-16" data-id="element-315" data-mp="37pbljggh42j9">
        <InView data-id="element-316" data-mp="32q8i20g564de">
          <SlideHeadline lead="One format." follow="Many use cases." data-id="element-317" data-mp="32qi63ihmm1gg" />
        </InView>
        <InView delay={0.06} data-id="element-318" data-mp="1dfhi61zmifqa">
          <p className="text-[14.5px] leading-[1.7] text-navy/65" data-id="element-319" data-mp="18ek2bw235xry">
            The format that introduces DME phenotyping can also do other jobs: research, door openers, study updates,
            email outreach and congress activation.
          </p>
        </InView>
      </div>

      <InView delay={0.12} y={26} className="mt-14" data-id="element-320" data-mp="vq1q56s8uz65">
        <ul className="grid gap-px overflow-hidden rounded-[28px] bg-navy/[0.08] ring-1 ring-navy/[0.08] sm:grid-cols-2 lg:grid-cols-3" data-id="element-321" data-mp="10qpd9hdcqvv3">
          {useCases.map(useCase => {
          const Icon = ICONS[useCase.id];
          return <li key={useCase.id} className="flex flex-col bg-paper p-7" data-id="element-322" data-mp="1eivruz0uwusf">
                <div className="flex items-center gap-3" data-id="element-323" data-mp="1eh183o1bn8px">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-navy text-mint" data-id="element-324" data-mp="1jhp7awzpevv8">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-325" data-mp="1ofqp7ele8p54" />
                  </span>
                  <h3 className="font-display text-[20px] font-semibold leading-tight text-navy" data-id="element-326" data-mp="3ladefhfgy3ga">{useCase.name}</h3>
                </div>
                <p className="mt-5 text-[14px] leading-snug text-navy/50" data-id="element-327" data-mp="3qaixi97oahmr">
                  <span className="text-[10px] uppercase tracking-[0.18em] text-navy/40" data-id="element-328" data-mp="3i8ico8p7gy3z">Barrier · </span>
                  {useCase.barrier}
                </p>
                <p className="mt-auto pt-5 text-[14.5px] leading-snug text-navy" data-id="element-329" data-mp="3s5mxo57benj7">{useCase.example}</p>
              </li>;
        })}
        </ul>
      </InView>

      <InView delay={0.24} data-id="element-330" data-mp="3n96cnjvewpac">
        <p className="mt-14 max-w-[40ch] border-t border-navy/[0.12] pt-8 font-display text-[26px] font-semibold leading-[1.12] tracking-[-0.02em] text-navy sm:text-[32px]" data-id="element-331" data-mp="50p04chxddvm">
          The value of a Snak is not only who sees it —{' '}
          <span className="text-navy/45" data-id="element-332" data-mp="epp46abaazgo">but what barrier it helps remove.</span>
        </p>
      </InView>
    </Slide>;
}